__turbopack_context__.v({
  "content": "PriceDetails-module__aIVeBG__content",
  "contrast": "PriceDetails-module__aIVeBG__contrast",
  "depositBadge": "PriceDetails-module__aIVeBG__depositBadge",
  "divider": "PriceDetails-module__aIVeBG__divider",
  "footer": "PriceDetails-module__aIVeBG__footer",
  "iconContainer": "PriceDetails-module__aIVeBG__iconContainer",
  "includedItem": "PriceDetails-module__aIVeBG__includedItem",
  "includedList": "PriceDetails-module__aIVeBG__includedList",
  "includedSection": "PriceDetails-module__aIVeBG__includedSection",
  "loyaltyBenefitsDivider": "PriceDetails-module__aIVeBG__loyaltyBenefitsDivider",
  "loyaltyBenefitsSection": "PriceDetails-module__aIVeBG__loyaltyBenefitsSection",
  "pricingLink": "PriceDetails-module__aIVeBG__pricingLink",
  "pricingNote": "PriceDetails-module__aIVeBG__pricingNote",
  "pricingNoteContent": "PriceDetails-module__aIVeBG__pricingNoteContent",
  "pricingNoteHasFromPrice": "PriceDetails-module__aIVeBG__pricingNoteHasFromPrice",
  "pricingNoteSection": "PriceDetails-module__aIVeBG__pricingNoteSection",
  "pricingNoteText": "PriceDetails-module__aIVeBG__pricingNoteText",
  "questionMarkCircle": "PriceDetails-module__aIVeBG__questionMarkCircle",
  "totalDivider": "PriceDetails-module__aIVeBG__totalDivider",
  "totalPrice": "PriceDetails-module__aIVeBG__totalPrice",
  "totalPriceValue": "PriceDetails-module__aIVeBG__totalPriceValue",
  "totalSection": "PriceDetails-module__aIVeBG__totalSection",
  "tripDetailItem": "PriceDetails-module__aIVeBG__tripDetailItem",
  "tripDetailsSection": "PriceDetails-module__aIVeBG__tripDetailsSection",
});
